import DeviationSidebarGrid from './DeviationSidebarGrid';
import DeviationSidebarGrid6Thumbs from './DeviationSidebarGrid.sidebar_6_thumbs';
import DeviationSidebarGrid9Thumbs from './DeviationSidebarGrid.sidebar_9_thumbs';
import { withFeatureBranch } from '../../../redux/flags';
export default withFeatureBranch({
    sidebar_6_thumbs: DeviationSidebarGrid6Thumbs,
    sidebar_9_thumbs: DeviationSidebarGrid9Thumbs,
})(DeviationSidebarGrid);
//# sourceMappingURL=index.js.map